import { GetAccountInfoResponse } from '@cbinsights/salesforceservice/salesforceservice';
import {
  UseMutationResult,
  UseQueryResult,
  useMutation,
  useQuery,
} from 'react-query';
import { GetSalesforceAccountInfo } from '.';
import { getSalesforceAccountInfo } from '../api/GetSalesforceAccountInfo';

type Params = Parameters<typeof getSalesforceAccountInfo>[0];
type Return = GetAccountInfoResponse;

export const useGetSalesforceAccountInfoQuery = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetSalesforceAccountInfo, Params]>(
    ['GetSalesforceAccountInfo', params],
    () => getSalesforceAccountInfo(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );

export const useGetSalesforceAccountInfoMutation = (): UseMutationResult<
  Return,
  Error,
  Params
> =>
  useMutation<Return, Error, Params>((params) =>
    getSalesforceAccountInfo(params)
  );
